@use "styles/mixins/_fonts.scss" as fonts;

.tag {
  @include fonts.body-accent-xs;

  display: inline-flex;
  padding: var(--size-spacing-2xs) var(--size-spacing-xs);
  align-items: center;
  gap: var(--size-spacing-xs);
  border-radius: var(--size-border-radius-s);
  width: fit-content;
  height: fit-content;
  color: var(--color-text-default);

  &.default {
    .icon {
      color: var(--color-icon-default);
    }

    background-color: var(--color-background-subtle);
  }

  &.success {
    .icon {
      color: var(--color-icon-success);
    }

    background-color: var(--color-background-success);
  }

  &.warning {
    .icon {
      color: var(--color-icon-warning);
    }

    background-color: var(--color-background-warning);
  }

  &.error {
    .icon {
      color: var(--color-icon-error);
    }

    background-color: var(--color-background-error);
  }

  &.bookclub {
    .icon {
      color: var(--color-icon-bookclub);
    }

    background-color: var(--color-background-bookclub);
  }

  &.cineclub {
    .icon {
      color: var(--color-icon-cineclub);
    }

    background-color: var(--color-background-cineclub);
  }

  &.pro-edito {
    .icon {
      color: var(--color-icon-pro-edito);
    }

    background-color: var(--color-background-pro-edito);
  }

  &.headline {
    .icon {
      color: var(--color-icon-headline);
    }

    background-color: var(--color-background-headline);
  }

  &.like {
    .icon {
      color: var(--color-icon-brand-primary);
    }

    background-color: var(--color-background-subtle);
  }

  &.new {
    color: var(--color-text-inverted);
    background-color: var(--color-background-brand-primary);
  }
}
